import useIsInappWebview from "./useIsInappWebview";
import useRole from "./useRole";

export default function useIsRecordSeparatedPage() {
  const isInappWebview = useIsInappWebview();
  const isPatient = useRole();

  return isPatient && isInappWebview;
}
